import { useWindowSize } from '@vueuse/core'
import { computed, ref } from 'vue'

export const useScreenSize = () => {
    // SSR-safe: on server there is no window, so we use a stable fallback width.
    // This prevents "window is not defined" crashes during SSR render.
    const { width } = import.meta.client ? useWindowSize() : { width: ref(1024) }

    const isMobile = computed(() => width.value <= 640)
    const isTablet = computed(() => width.value <= 768)
    const isDesktop = computed(() => width.value > 768)
    const isXl = computed(() => width.value >= 1610)

    return {
        isTablet,
        isMobile,
        isDesktop,
        isXl,
    }
}